/******** For Gift certificate validation ******/
// list of flower images to feed to each nav item.
// make sure the key matches the nav item 
const flowers = {
    "New for Spring Planting": "https://www.brecks.com/cdn/shop/files/81448.webp?&width=100",
    "New for Fall Planting": "https://www.brecks.com/cdn/shop/files/94933.webp?&width=100",
    "Other Fall Bulbs": "https://www.brecks.com/cdn/shop/files/68298.webp?&width=100",
    "Fall Bulb Collections & Mixes": "https://www.brecks.com/cdn/shop/files/94769.webp?&width=100",
    "Other Spring Bulbs": "https://www.brecks.com/cdn/shop/files/97008.webp?&width=100",
    "Spring Bulb Collections & Mixes": "https://www.brecks.com/cdn/shop/files/Spring_Bulb_Mix.webp?&width=100",
    "Other Sun Perennials": "https://www.brecks.com/cdn/shop/files/69807.webp?&width=100",
    "Sun Perennials Collections & Mixes": "https://www.brecks.com/cdn/shop/files/76843A.webp?&width=100",
    "Other Shade Perennials": "https://www.brecks.com/cdn/shop/files/97111.webp?&width=100",
    "Shade Perennials Collections & Mixes": "https://www.brecks.com/cdn/shop/files/65327.webp?&width=100",
    "Garden Tools and Supplies": "https://www.brecks.com/cdn/shop/files/65602.webp?&width=100",
    "Backyard Birding": "https://www.brecks.com/cdn/shop/files/78709.webp?&width=100",
    "Fertilizers": "https://www.brecks.com/cdn/shop/files/84749.webp?&width=100",
    "Gardening Books": "https://www.brecks.com/cdn/shop/files/60506.webp?&width=100",
    "Garden Décor": "https://www.brecks.com/cdn/shop/files/95625.webp?&width=100",
    "Solar and Wind": "https://www.brecks.com/cdn/shop/files/61493.webp?&width=100",
    "Begonias": "https://www.brecks.com/cdn/shop/files/65635.webp?v=1721900270&width=100",
    "Calla Lilies": "https://www.brecks.com/cdn/shop/files/20610A.webp?&width=100",
    "Cannas": "https://www.brecks.com/cdn/shop/files/80206.webp?v=1721901920&width=800",
    "Dahlias": "https://www.brecks.com/cdn/shop/files/62461.webp?v=1721898664&width=100",
    "Gladiolus": "https://www.brecks.com/cdn/shop/files/69375A.webp?v=1721897568&width=100",
    "Lilies": "https://www.brecks.com/cdn/shop/files/67373A.webp?v=1721901666&width=100",
    "Ranunculus": "https://www.brecks.com/cdn/shop/files/74613A.webp?v=1721899415&width=100",
    "Alliums": "https://www.brecks.com/cdn/shop/files/09779.webp?v=1721894857&width=800",
    "Amaryllis": "https://www.brecks.com/cdn/shop/files/94651.webp?v=1728418052&width=100",
    "Anemone": "https://www.brecks.com/cdn/shop/files/60729.webp?v=1740588810&width=800",
    "Bearded Iris": "https://www.brecks.com/cdn/shop/files/75931.webp?v=1721899771&width=100",
    "Crocus": "https://www.brecks.com/cdn/shop/files/63946A.webp?v=1721897508&width=800",
    "Cyclamen": "https://www.brecks.com/cdn/shop/files/67343A.webp?v =1721897939&width=100",
    "Daffodils": "https://www.brecks.com/cdn/shop/files/67225A.webp?v=1721897512&width=100",
    "Dutch Iris": "https://www.brecks.com/cdn/shop/files/17814A.webp?v=1721899398&width=100",
    "Fritillaria": "https://www.brecks.com/cdn/shop/files/91174.webp?v=1721902366&width=100",
    "Grape Hyacinths": "https://www.brecks.com/cdn/shop/files/39466.webp?v=1721902270&width=100",
    "Hyacinths": "https://www.brecks.com/cdn/shop/files/67390.webp?v=1721895559&width=100",
    "Snowdrops": "https://www.brecks.com/cdn/shop/files/67298A.webp?v=1721896444&width=100",
    "Spanish Bells": "https://www.brecks.com/cdn/shop/files/02283.webp?v=1721901560&width=100",
    "Tulips": "https://www.brecks.com/cdn/shop/files/09776A.webp?v=1721895106&width=100",
    "Asters": "https://www.brecks.com/cdn/shop/files/92856.webp?v=1721901478&width=100",
    "Astrantia": "https://www.brecks.com/cdn/shop/files/83581.webp?v=1721894523&width=100",
    "Bee Balm": "https://www.brecks.com/cdn/shop/files/71117A.webp?v=1721894707&width=100",
    "Columbine": "https://www.brecks.com/cdn/shop/files/68207A.webp?v=1721895901&width=100",
    "Coneflowers": "https://www.brecks.com/cdn/shop/files/86826.webp?v=1721901837&width=100",
    "Daylilies": "https://www.brecks.com/cdn/shop/files/66925A.webp?v=1721896583&width=100",
    "Geraniums": "https://www.brecks.com/cdn/shop/files/68186A.webp?v=1721897923&width=100",
    "Helenium": "https://www.brecks.com/cdn/shop/files/83503.webp?v=1721897353&width=100",
    "Hibiscus": "https://www.brecks.com/cdn/shop/files/74887A.webp?v=1721896854&width=100",
    "Hollyhocks": "https://www.brecks.com/cdn/shop/files/76843A.webp?v=1721896391&width=100",
    "Iris": "https://www.brecks.com/cdn/shop/files/17814A.webp?v=1721899398&width=100",
    "Milkweed": "https://www.brecks.com/cdn/shop/files/76783.webp?v=1721901550&width=100",
    "Oriental Poppies": "https://www.brecks.com/cdn/shop/files/82127.webp?v=1721894227&width=100",
    "Peonies": "https://www.brecks.com/cdn/shop/files/62911A.webp?v=1721900347&width=100",
    "Phlox": "https://www.brecks.com/cdn/shop/files/05851A.webp?v=1721900250&width=100",
    "Red Hot Pokers": "https://www.brecks.com/cdn/shop/files/73503A.webp?v=1721898123&width=100",
    "Roses": "https://www.brecks.com/cdn/shop/files/63262A.webp?v=1721894407&width=100",
    "Sedum": "https://www.brecks.com/cdn/shop/files/96307.webp?v=1721895536&width=100",
    "Yarrow": "https://www.brecks.com/cdn/shop/files/96934.webp?v=1721902244&width=100",
    "Astilbe": "https://www.brecks.com/cdn/shop/files/73742A.webp?v=1721894520&width=100",
    "Bleeding Hearts": "https://www.brecks.com/cdn/shop/files/74573A.webp?v=1721899731&width=100",
    "Ferns": "https://www.brecks.com/cdn/shop/files/83641.webp?v=1734711142&width=800",
    "Hellebores": "https://www.brecks.com/cdn/shop/files/97145.webp?v=1732569101&width=800",
    "Heuchera": "https://www.brecks.com/cdn/shop/files/76000A.webp?v=1721898006&width=100",
    "Hostas": "https://www.brecks.com/cdn/shop/files/73741A.webp?v=1721898109&width=100",
    "Lily of the Valley": "https://www.brecks.com/cdn/shop/files/19562A.webp?v=1721898938&width=100",
    "Toad Lilies": "https://www.brecks.com/cdn/shop/files/71110.webp?v=1721902081&width=100",
    "Foxgloves": "https://www.brecks.com/cdn/shop/files/97342.webp?v=1734701501&width=100",
    "Caladiums": "https://www.brecks.com/cdn/shop/files/97092.webp?v=1734701502&width=800"
}

//mobile navigation
function waitForMobileNav() {
    if (window.jQuery && $('.mobile-menu__link').length) {
        // TEST CHANGES
        $('.mobile-menu__link').each(function () {
            if (!$(this).find('.roi-flower-image').length) {
                const link = $(this);
                const flower = link.find('span.mobile-menu__link__text').text().trim();
                const image = flowers[flower];
                if (image) {
                    link.prepend(`<img src="${image}" alt="${flower}" class="roi-flower-image"/>`);
                }
            }
        });
    } else {
        setTimeout(function () { waitForMobileNav(); }, 50);
    }
}
waitForMobileNav();

//desktop navigation
setInterval(function () {
    if (window.jQuery && $('.meganav__list-child a').length) {
        // TEST CHANGES
        $('.meganav__list-child a').each(function () {
            if (!$(this).find('.roi-flower-image').length) {
                const link = $(this);
                const flower = link.contents().filter(function(){ 
  return this.nodeType == Node.TEXT_NODE; 
})[0].nodeValue.trim();
                const image = flowers[flower];
                if (image) {
                    link.prepend(`<img src="${image}" alt="${flower}" class="roi-flower-image"/>`);
                }
            }
        });
    }
}, 250);
/******** For Gift certificate validation End ******/